<div class="container-fluid" *ngIf="purchase">
    <div class="row title-container align-items-center mb-5" style="padding: 10px;">
        <img src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Detalhes da recarga</span>
    </div>

    <!--Box 1-->
    <!--<div class="form-box container-fluid">
        <div class="row">
            <div class="col-12 form-title pt-4">Dados da recarga</div>
            <div class="py-2 container-fluid">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Código recarga:</div>
                                <div class="custom-p">{{purchase.purchaseId}}</div>
                            </div>
                        </div>
                    </div>

                    <--<div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Identificação:</div>
                                <div *ngIf="purchase.purchaseDescription" class="custom-p">{{purchase}}</div>
                                <div *ngIf="!purchase.purchaseDescription" class="custom-p">sem identificação</div>
                            </div>
                        </div>
                    </div>--
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Data da recarga:</div>
                                <div class="custom-p">{{purchase.purchaseDate | date: "dd/MM/yyyy"}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Valor:</div>
                                <div *ngIf="purchase.purchaseValue > 0" class="custom-p">
                                    {{purchase.purchaseValue | currency:'BRL':true}}</div>
                                <div *ngIf="purchase.purchaseValue <= 0" class="custom-p">R$ 0,00</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Valor da taxa:</div>
                                <div *ngIf="purchase.purchaseFee > 0" class="custom-p">
                                    {{purchase.purchaseFee | currency:'BRL':true}}</div>
                                <div *ngIf="purchase.purchaseFee <= 0" class="custom-p">R$ 0,00</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>-->

    <!--Box 2-->
    <!--<div *ngIf="pedido.origem || pedido.destino" class="form-box container-fluid">
        <div class="row">
            <div class="col-12 form-title pt-4">Pagamento (origem)</div>
            <div class="py-2 container-fluid">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Banco:</div>
                                <div class="custom-p">{{pedido.origem.bancoNome}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Número do banco:</div>
                                <div class="custom-p">{{pedido.origem.banco}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Agência:</div>
                                <div class="custom-p">{{pedido.origem.agencia}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Conta:</div>
                                <div class="custom-p">{{pedido.origem.conta}}-{{pedido.origem.digitoConta}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 form-title pt-4">Pagamento (destino)</div>
            <div class="py-2 container-fluid">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Banco:</div>
                                <div class="custom-p">{{pedido.destino.instituicao}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Número do banco:</div>
                                <div class="custom-p">{{pedido.destino.banco}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Agência:</div>
                                <div class="custom-p">{{pedido.destino.agencia}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Conta:</div>
                                <div class="custom-p">{{pedido.destino.contaBancaria}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Código de identificação:</div>
                                <div class="custom-p">{{pedido.destino.identificador}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Favorecido:</div>
                                <div class="custom-p">{{pedido.destino.razaoSocial}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">CNPJ:</div>
                                <div class="custom-p">{{pedido.destino.cnpj}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>-->

    <!--Box 3-->
    <div class="form-box container-fluid">
        <div class="row">
            <div class="col-12 form-title pt-4">Dados da recarga: {{purchase.purchaseId}}</div>
            <div class="col-lg-2 col-md-2 col-sm-12" style="max-inline-size: max-content;">
                <button type="button" class="list-header-filter-button" style="margin-right: 5px;" (click)="exportPdf()">
                    Baixar pedido de recarga
                </button>
            </div>
            <div class="py-2 container-fluid">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label" *ngIf="purchase.products.length > 1">Produtos:</div>
                                <div class="custom-p-label" *ngIf="purchase.products.length <= 1">Produto:</div>
                                <div class="custom-p">{{ purchase.products?.join(", ") }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Quantidade de produtos:</div>
                                <div class="custom-p">{{purchase.products.length}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Data e hora da recarga:</div>
                                <div class="custom-p">{{purchase.purchaseDate | date: "dd/MM/yyyy HH:mm"}}</div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="!(purchase.purchaseState === SituacaoCompra.NaoProcessado || purchase.purchaseState === SituacaoCompra.Cancelado || purchase.purchaseState === SituacaoCompra.Rascunho)" class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Data e hora de provisionamento:</div>
                                <div class="custom-p" *ngIf="purchase.purchaseItens[0].order.releaseDate">
                                    {{purchase.purchaseItens[0].order.releaseDate | date: "dd/MM/yyyy HH:mm"}}</div>
                                <div class="custom-p" *ngIf="!purchase.purchaseItens[0].order.releaseDate">Sem data e hora de provisionado cadastrada
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Valor total da recarga:</div>
                                <div *ngIf="purchase.purchaseValue > 0" class="custom-p">
                                    {{purchase.purchaseValue | currency:'BRL':true}}</div>
                                <div *ngIf="purchase.purchaseValue <= 0" class="custom-p">R$ 0,00</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pr-5">
                            <div class="custom-p-label">Valor a ser pago:</div>
                            <div *ngIf="purchase.purchaseToPayValue > 0" class="custom-p">
                                {{purchase.purchaseToPayValue | currency:'BRL':true}}</div>
                            <div *ngIf="purchase.purchaseToPayValue <= 0" class="custom-p">R$ 0,00</div>
                        </div>
                    </div>

                    <!--Meio de pagamento selecionado-->
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right" *ngIf="!purchase.purchaseState === SituacaoCompra.Rascunho">
                        <div class="custom-pr-5">
                            <div class="custom-p-label">Meio de pagamento:</div>
                            <div class="custom-p" *ngIf="purchase.paymentMethodId">
                                {{purchase.paymentMethodDescription}}
                                <ng-container *ngIf="purchase?.boleto?.arquivo && !purchase?.pix">
                                    <img (click)="openBoleto()" src="../../../../../../assets/icons/boleto-icon.png" class="boleto ml-2" *ngIf="purchase.paymentMethodId === 1">
                                </ng-container>
                                <ng-container *ngIf="purchase?.pix?.brCode && !purchase?.boleto">
                                    <img (click)="showModalQRCodePIX(pixQRCode)" src="../../../../../../assets/icons/qr-code.png" class="boleto ml-2" *ngIf="purchase.paymentMethodId === 4">
                                </ng-container>     
                                <ng-container  *ngIf="!purchase?.pix && !purchase?.boleto">
                                    <button type="button" class="custom-button-full m-2" (click)="generateDeposit()">
                                        Gerar novo depósito
                                    </button>
                                </ng-container>

                            </div>
                            <div class="custom-p" *ngIf="!purchase.paymentMethodId">Saldo em conta</div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Valor da taxa:</div>
                                <div *ngIf="purchase.purchaseFee > 0" class="custom-p">
                                    {{purchase.purchaseFee | currency:'BRL':true}}</div>
                                <div *ngIf="purchase.purchaseFee <= 0" class="custom-p">R$ 0,00</div>
                            </div>
                        </div>
                    </div>

                    <!--Uso do saldo em conta da cedente-->
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right" *ngIf="!purchase.purchaseState === SituacaoCompra.Rascunho">
                        <div class="custom-pr-5">
                            <div class="custom-p-label">Uso do saldo em conta da cedente</div>
                            <div class="custom-p" *ngIf="purchase.purchaseUseBalance">SIM</div>
                            <div class="custom-p" *ngIf="!purchase.purchaseUseBalance">NÃO</div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Valor a ser disponibilizado:</div>
                                <div class="custom-p">{{purchase.purchaseValueToDeliver | currency:'BRL':true}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right">
                        <div class="custom-pr-5">
                            <div class="custom-input-container">
                                <div class="custom-p-label">Status:</div>
                                <div id="numero" class="custom-p">{{purchase.purchaseStateDescription}}</div>
                            </div>
                        </div>
                    </div>

                    <!--Comentários-->
                    <!-- <div *ngIf="comentarios && comentarios !== []" class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pr-5">
                            <div class="custom-p-label">Comentários</div>
                            <div class="custom-p" *ngFor="let comentario of comentarios">{{comentario}}</div>
                        </div>
                    </div> -->
                </div>

                <div class="row button-container mt-5 mb-3">
                    <div class="col-12 text-right">
                        <!--<button *ngIf="purchase.purchaseState !== 1" type="button" class="custom-button-full m-2" (click)="copiar()">
                            Copiar Recarga
                        </button>-->

                        <button *ngIf="purchase.purchaseState === 1 || purchase.purchaseState === 8" type="button" class="custom-button-full m-2" (click)="continuar()">
                            Continuar Recarga
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Box 4 -->
    <div class="form-box container-fluid">
        <div class="row">
            <div class="col-4 form-title pt-4">Produtos</div>
            <div class="col-8">
                <div class="row float-right">
                    <div class="page-custom pt-4 mr-3">
                        <pagination-controls (pageChange)="productsPage = $event" responsive="true" previousLabel="" nextLabel="" id="pageProducts"></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table class="list-table table table-striped">
                <thead class="list-table-head">
                    <th>Produto</th>
                    <th>Valor</th>
                    <th>Comentário</th>
                    <th>Situação</th>
                    <!--<th>Ação</th>-->
                </thead>
                <tbody class="list-table-row">
                    <tr *ngFor="let item of purchase.purchaseItens | paginate: { itemsPerPage: 25, currentPage: productsPage, id: 'pageProducts'}" class=" list-table-cell" class="clickable">
                        <td>{{item.order.productDescription}}</td>

                        <td style="white-space: nowrap;">{{item.order.orderValueToDeliver | currency:'BRL':true}}</td>

                        <td>{{item.order.orderDescription}}</td>

                        <td style="white-space: nowrap;">{{item.order.orderStateDescription}} <span *ngIf="item.order.orderState === SituacaoPedido.Desprovisionado">por
                                {{item.gestorNomeAlteracao}}</span></td>
                        <td class="text-center">
                            <div ngbDropdown class="d-inline-block
                                        menu-option" placement="left">
                                <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                    <img src="assets/icons/menu.png" />
                                </button>
                                <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                    <section class="custom-context-menu">
                                        <div ngbDropdownItem (click)="showColaboradores(item.order.orderId, item.order.productDescription)">
                                            <img src="assets/icons/pencil-purple.png" class="mr-2" />Favorecidos recarga
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="form-box container-fluid" *ngIf="showCola">
        <div class="row">
            <div class="col-4 form-title pt-4">Favorecidos: {{productDescription}}</div>
            <div class="col-8">
                <div class="row float-right">
                    <div (click)="showFilter(filtro)" class="list-select pt-4 mr-3">
                        <button _ngcontent-khv-c20="" class="list-select" type="button">
                            Aplicar filtro
                        </button>
                    </div>
                    <div class="list-filter-show-item pt-4 mr-3">
                        Mostrar:
                        <select [(ngModel)]="showItem" (ngModelChange)="changeLimit($event)" class="ng-untouched ng-pristine ng-valid">
                            <option _ selected="" value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                    <div class="page-custom pt-4 mr-3">
                        <pagination-controls  id="collaboratorsPurchaseDetails" (pageChange)="getOrderItems($event, orderId)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table class="list-table table table-striped" *ngIf="orderItemsList.length > 0">
                <thead class="list-table-head">
                    <th>Nome</th>
                    <th>CPF</th>
                    <th>Matrícula</th>
                    <th>Centro de Custo</th>
                    <th>Unidade</th>
                    <th>Departamento</th>
                    <th>Valor</th>
                    <th>Comentário</th>
                    <th>Situação</th>
                    <th>Ação</th>
                </thead>
                <tbody class="list-table-row">
                    <tr *ngFor="let item of orderItemsList | paginate: { itemsPerPage: showItem, currentPage: currentPage, id: 'collaboratorsPurchaseDetails', totalItems: totalItems}" class=" list-table-cell" class="clickable">
                        <td>{{item.name}}</td>

                        <td  style="white-space: nowrap;">
                            <span *ngIf="item.document || item.document != null">{{ item.document | cpf }}</span>
                            <span *ngIf="!item.document || item.document == null"></span>
                        </td>

                        <td>{{item.register}}</td>

                        <td style="white-space: nowrap;">{{item.costCenter}}</td>

                        <td>{{item.unit}}</td>

                        <td style="white-space: nowrap;">{{item.departament}}</td>

                        <td>{{item.value | currency:'BRL':true}}</td>

                        <td style="white-space: nowrap;">{{item.comments }}</td>

                        <td>{{item.situationDescription}}</td>

                        <td class="text-center">
                            <div ngbDropdown class="d-inline-block
                                        menu-option" placement="left">
                                <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                    <img src="assets/icons/menu.png" />
                                </button>
                                <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                    <section class="custom-context-menu">
                                        <div ngbDropdownItem (click)="showDesprovisionar(desprovisionarmodal, item)"  *ngIf="item.situationId === SituacaoPedidoItem.EmCricao || item.situationId === SituacaoPedidoItem.Criado || item.situationId === SituacaoPedidoItem.NaoProcessado || item.situationId === SituacaoPedidoItem.AguardandoReprocessamento">
                                            <img src="assets/icons/pencil-purple.png" class="mr-2" />Desprovisionar
                                        </div>
                                        <div ngbDropdownItem *ngIf="(item.orderItemState === SituacaoCompra.NaoProcessado || item.orderItemState === SituacaoPedidoItem.AguardandoReprocessamento)"
                                            (click)="showReprocessar(reprocessarmodal, purchaseItensModal.order, item)">
                                            <img src="assets/icons/redo.png" class="mr-2" />Reprocessar
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div *ngIf="orderItemsList.length === 0" class="text-center mb-5 mt-5">
                <h6>
                    Nenhum favorecido carregado. Faça uma busca para retornar a lista de favorecidos
                </h6>
            </div>
        </div>
    </div>
</div>

<ng-template #colaboradoresmodal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Favorecidos
            </h5>
        </div>
    </div>
    <div class="col-12 clean-modal-content">
        <div class="table-responsive">
            <table class="list-table table table-striped">
                <thead class="list-table-head">
                    <th>Nome</th>
                    <th>CPF</th>
                    <th>Valor</th>
                    <th>Comentário</th>
                    <!--<th>Favorecido apto?</th>-->
                    <th>Situação</th>
                    <th>Ação</th>
                </thead>
                <tbody class="list-table-row">
                    <tr *ngFor="let item of purchaseItensModal.order.orderItens | paginate: { itemsPerPage: 8, currentPage: 1 }" class=" list-table-cell" class="clickable">
                        <td>{{item.name}}</td>

                        <td style="white-space: nowrap;">{{item.document.toString() | cpf}}</td>

                        <td style="white-space: nowrap;">{{item.providedValue | currency:'BRL':true}}</td>

                        <td>{{item.comments}}</td>

                        <!--<td>-->
                            <!-- <span *ngIf="verificaAplicativo(item.statusApp)"><img class="img-status"
                                    src="./assets/icons/status-green.png" /> </span>
                            <span *ngIf="!verificaAplicativo(item.statusApp)"><img class="img-status"
                                    src="./assets/icons/status-yellow.png" /> </span> -->
                            <!-- <span *ngIf="item.hasApp"><img class="img-status"
                                    src="./assets/icons/status-green.png" /> </span>
                            <span *ngIf="!item.hasApp"><img class="img-status"
                                    src="./assets/icons/status-yellow.png" /> </span>
                        </td> -->
                        <td style="white-space: nowrap;">{{item.orderItemStateDescription}} <!-- <span *ngIf="item.orderItemState === SituacaoPedidoItem.Desprovisionado">por
                                {{item.gestorNomeAlteracao}}</span> --></td>
                        <td class="text-center">
                            <div ngbDropdown class="d-inline-block
                                        menu-option" placement="left">
                                <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                    <img src="assets/icons/menu.png" />
                                </button>
                                <div *ngIf="((purchaseItensModal.orderState === SituacaoCompra.ParcialmenteProcessado || purchaseItensModal.orderState === SituacaoCompra.NaoProcessado) && (item.orderItemState === SituacaoPedidoItem.NaoProcessado || item.orderItemState === SituacaoPedidoItem.AguardandoReprocessamento)) || (item.orderItemState === SituacaoPedidoItem.EmCricao || item.orderItemState === SituacaoPedidoItem.Criado || item.orderItemState === SituacaoPedidoItem.NaoProcessado || item.orderItemState === SituacaoPedidoItem.AguardandoReprocessamento)" ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                    <section class="custom-context-menu">
                                        <div ngbDropdownItem (click)="showDesprovisionar(desprovisionarmodal, purchaseItensModal.order, item)" *ngIf="item.orderItemState === SituacaoPedidoItem.EmCricao || item.orderItemState === SituacaoPedidoItem.Criado || item.orderItemState === SituacaoPedidoItem.NaoProcessado || item.orderItemState === SituacaoPedidoItem.AguardandoReprocessamento">
                                            <img src="assets/icons/close.png" class="mr-2" />Desprovisionar
                                        </div>

                                        <div ngbDropdownItem *ngIf="(purchaseItensModal.orderState === SituacaoPedido.ParcialmenteProcessado || purchaseItensModal.orderState === SituacaoCompra.NaoProcessado) && (item.orderItemState === SituacaoCompra.NaoProcessado || item.orderItemState === SituacaoPedidoItem.AguardandoReprocessamento)"
                                            (click)="showReprocessar(reprocessarmodal, purchaseItensModal.order, item)">
                                            <img src="assets/icons/redo.png" class="mr-2" />Reprocessar
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel" type="button" (click)="modal.dismiss('Close click')">
        Fechar
        </button>
    </div>
</ng-template>

<ng-template #reprocessarmodal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Reprocessar favorecido
            </h5>
            <p class="clean-modal-subtitle">
                Tem certeza que deseja reprocessar o favorecido?
            </p>
        </div>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel" (click)="modal.dismiss('Close click')">
            Não
        </button>
        <button class="custom-filter-button" (click)="reprocessar(order, pedidoItemToReprocessar);modal.dismiss('Close click')">
            Sim
        </button>
    </div>
</ng-template>


<ng-template #desprovisionarmodal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Desprivionar favorecido
            </h5>
            <p class="clean-modal-subtitle">
                Tem certeza que deseja desprivionar o favorecido?
            </p>
        </div>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel" (click)="modal.dismiss('Close click')">
            Não
        </button>
        <button class="custom-filter-button" (click)="desprovisionar(orderItemToDesprovisionar);modal.dismiss('Close click')">
            Sim
        </button>
    </div>
</ng-template>

<ng-template #pixQRCode let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12" style="text-align: center;">
            <h5 class="modal-title clean-modal-title" >
                Pix QRCODE
            </h5>
            <img *ngIf="purchase.pix" src="{{'data:image/png;base64,' + purchase.pix.imagemBRCode}}" class="qrcode-img"/>
        </div>
    </div>
</ng-template>

<!--Modal do Filtro-->
<ng-template #filtro let-modal>
    <!--<div class="container custom-filter">
        <div class="row mx-5">-->
            <div class="col-12 modal-header clean-modal-header">
                <div class="col-md-12">
                    <h5 class="clean-modal-title">Aplicar filtro</h5>
                </div>
            </div>
            <!-- <div class="col-lg-3 col-md-6 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <input id="colaboradorId" #colaboradorId class="custom-filter-input" type="text" value="{{ filtroCodigo }}" />
                    <label class="custom-filter-label" for="colaboradorId">Código:</label>
                </div>
            </div> -->
            <div class="row col-12 clean-modal-content">
                <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                    <div class="custom-filter-input-container">
                        <label class="clean-filter-label" for="nome">Nome:</label>
                        <input id="nome" #nome class="clean-filter-input" type="text" value="{{ filtroNome }}" autocomplete="off"/>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                    <div class="custom-filter-input-container">
                        <label class="clean-filter-label" for="cpf">CPF:</label>
                        <input id="cpf" #cpf class="clean-filter-input" type="text" value="{{ filtroCPF }}" autocomplete="off"/>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                    <div class="custom-filter-input-container">
                        <label class="clean-filter-label" for="matricula">Matricula:</label>
                        <input id="matricula" #matricula class="clean-filter-input" type="text" value="{{ filtroMatricula }}"autocomplete="off" />
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                    <div class="custom-filter-input-container">
                        <label class="dropdown-label">Centro de Custo:</label>
                        <ng-multiselect-dropdown [data]="filtroCentroCustoDropDownList" [(ngModel)]="filtroCentroCustoSelectedItems" [settings]="dropDownSettings" [placeholder]="
                                'Selecionar centros de custo'
                            " (onSelect)="onItemSelectFiltroCentroCusto($event)" (onSelectAll)="onSelectAllFiltroCentroCusto($event)" (onDeSelect)="onItemDeSelectFiltroCentroCusto($event)"></ng-multiselect-dropdown>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                    <div class="custom-filter-input-container">
                        <label class="dropdown-label" for="unidade">Unidade:</label>
                        <ng-multiselect-dropdown [data]="filtroUnidadeDropDownList" [(ngModel)]="filtroUnidadeSelectedItems" [settings]="dropDownSettings" [placeholder]="
                                'Selecionar unidades'
                            " (onSelect)="onItemSelectFiltroUnidade($event)" (onSelectAll)="onSelectAllFiltroUnidade($event)" (onDeSelect)="onItemDeSelectFiltroUnidade($event)"></ng-multiselect-dropdown>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                    <div class="custom-input-container">
                        <label class="dropdown-label" for="departamento">Departamento:</label>
                        <ng-multiselect-dropdown [data]="filtroDepartamentoDropDownList" [(ngModel)]="filtroDepartamentoSelectedItems" [settings]="dropDownSettings" [placeholder]="
                                'Selecionar departamentos'
                            " (onSelect)="onItemSelectFiltroDepartamento($event)" (onSelectAll)="onSelectAllFiltroDepartamento($event)" (onDeSelect)="onItemDeSelectFiltroDepartamento($event)"></ng-multiselect-dropdown>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                    <div class="custom-filter-input-container">
                        <label class="clean-filter-label" for="aplicativo">Apto?:</label>
                        <select id="aplicativo" #aplicativo class="clean-filter-input-select label-white" [value]="filtroAplicativo">
                            <option value="" selected>Selecione...</option>
                            <option value="">Indiferente</option>
                            <option value="true">Ativo</option>
                            <option value="false">Pendente</option>
                        </select>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                    <div class="custom-filter-input-container">
                        <label class="clean-filter-label" for="situacao">Situacao:</label>
                        <select id="situacao" #situacao class="clean-filter-input-select label-white" [value]="filtroSituacao">
                            <option value="" selected>Selecione...</option>
                            <option value="">Indiferente</option>
                            <option value="1">Ativo</option>
                            <option value="3">Desligado</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-12 clean-modal-footer">
                <button class="custom-filter-button custom-filter-button-just" type="button" (click)="
                        applyFilter(
                            nome.value,
                            cpf.value,
                            matricula.value,
                            filtroCentroCustoSelectedItems,
                            filtroUnidadeSelectedItems,
                            filtroDepartamentoSelectedItems,
                            aplicativo.value,
                            situacao.value
                        );
                        modal.dismiss('Close click')
                    ">
                    Aplicar
                </button>
            </div>
        <!--</div>
    </div>-->
</ng-template>
